import { z } from 'zod';

export const CommentListItemSchema = z.object({
  _id: z.any(),
  text: z.string(),
  entityId: z.string(),
  entityParentId: z.string().optional(),
  createdBy: z.any(),
  updatedAt: z.union([z.string(), z.date()]),
});

export type CommentListItem = z.infer<typeof CommentListItemSchema>;
